module.exports = __webpack_public_path__ + "img/signup-flow-logos.12babc84.png";